var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('image-upload',{attrs:{"editabel":false,"image":_vm.background},on:{"uploaded":_vm.apply,"imageDeleted":_vm.apply}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }